import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';

export const isCompanyTrialFeatureFlag = (company, trialDays) =>
  trialDays > 0 && company?.baseDetails?.accountType === 'trial' && company?.baseDetails?.companyTrialFeatureFlag;

export const getDatesDifferenceInDays = (company) => {
  const trialDate = dayjs(company?.baseDetails?.billing?.trialEndDate).format(DATE_FORMAT);
  const todayDate = dayjs().format(DATE_FORMAT);
  return dayjs(trialDate).diff(todayDate, 'day');
};
